export default __webpack_public_path__ + "static/media/crude-graph-on2.72475baf.svg";